import { render, staticRenderFns } from "./StudentOpportunityPage.vue?vue&type=template&id=0cddfae4&scoped=true&"
import script from "./StudentOpportunityPage.vue?vue&type=script&lang=ts&"
export * from "./StudentOpportunityPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddfae4",
  null
  
)

export default component.exports